import { createContext, useContext, useCallback } from "react";
import useApiService from "./ApiService";
import CONFIG from "./CONFIG";

const AgentFrameApiContext = createContext(null);

export function AgentFrameApiProvider({ children }) {
    const { get, post, put, del } = useApiService(CONFIG.SERVER_ASSISTANT);

    const getAgentFrames = useCallback(async (skip, limit) => {
        if (!skip) {
            skip = 0;
        }
        if (!limit) {
            limit = 10;
        }
        try {
            const response = await get(`/v1/assistant_frames?skip=${skip}&limit=${limit}`);
            return response.data;
        } catch (error) {
            console.error("Error fetching agent frames:", error);
            throw error;
        }
    }, [get]);

    const getAgentFrameById = useCallback(async (agentFrameId) => {
        try {
            const response = await get(`/v1/assistant_frames/${agentFrameId}`);
            return response.data;
        } catch (error) {
            console.error("Error fetching agent frame by ID:", error);
            throw error;
        }
    }, [get]);

    const createAgentFrame = useCallback(async (data) => {
        try {
            const response = await put(`/v1/assistant_frames`, data);
            return response.data;
        } catch (error) {
            console.error("Error creating agent frame:", error);
            throw error;
        }
    }, [put]);

    const updateAgentFrame = useCallback(async (agentFrameId, data) => {
        try {
            const response = await put(`/v1/assistant_frames/${agentFrameId}`, data);
            return response.data;
        } catch (error) {
            console.error("Error updating agent frame:", error);
            throw error;
        }
    }, [put]);

    const deleteAgentFrame = useCallback(async (agentFrameId) => {
        try {
            const response = await del(`/v1/assistant_frames/${agentFrameId}`);
            return response.data;
        } catch (error) {
            console.error("Error deleting agent frame:", error);
            throw error;
        }
    }, [del]);

    return (
        <AgentFrameApiContext.Provider
            value={{
                getAgentFrames,
                getAgentFrameById,
                createAgentFrame,
                updateAgentFrame,
                deleteAgentFrame
            }}
        >
            {children}
        </AgentFrameApiContext.Provider>
    )
}

export function useAgentFrameApi() {
    const context = useContext(AgentFrameApiContext);
    if (!context) {
        throw new Error("useAgentFrameApi must be used within an AgentFrameApiProvider");
    }
    return context;
}
